
 // header active
    $(document).ready(function(){
        $('.nav-center li a').click(function(){
            //remove all pre-existing active classes
            $('.nav-center li a.active').removeClass('active');
            $(this).addClass('active');
        });
    });

//   header script
function closeDiv() {
	document.getElementById("Dropdown2").style.display = "none";
}

document.addEventListener("DOMContentLoaded", function () {

  function removeClamp() {
    document.querySelectorAll('.jm-text.jm-review-content__body').forEach(el => {
      el.style.webkitLineClamp = "unset";
      el.style.overflow = "visible";
      el.style.display = "block";
      el.style.maxHeight = "none";
    });
  }

  // run multiple times (because app reload karta hai)
  setTimeout(removeClamp, 1000);
  setTimeout(removeClamp, 2000);
  setTimeout(removeClamp, 3000);

  // observe changes (FINAL fix)
  const observer = new MutationObserver(() => {
    removeClamp();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});


function openNav() {
	document.getElementById("mySidebar").style.width = "425px";
	document.getElementById("mySidebar").style.transition = "0.5s";
	document.getElementById("mySidebar").style.boxShadow = "0 0 0 10000px rgba(0,0,0,.75) ";
	document.getElementById("SidebarUl").style.opacity = "1";
	document.getElementById("SidebarUl").style.transition = "0.2s";
}
var abc;

function closeNav() {
	document.getElementById("mySidebar").style.width = "0";
	document.getElementById("mySidebar").style.boxShadow = "none ";
	document.getElementById("SidebarUl").style.opacity = "0 ";
	document.getElementById("SidebarUl").style.transition = "0.1s";
	var sd = document.getElementsByClassName("MobileNav2");
	for (let i = 0; i < sd.length; i++) {
		sd[i].style.width = "0";
		sd[i].style.left = "-100px";
	}

}

function OpenLi(clickedID) {
	var elementid = document.getElementById(clickedID);
	let str = clickedID;
	str = str.substring(1);
	// alert(str);
	// if ("NavItem1" == clickedID) {
	var Imgid = document.getElementById(str);
	Imgid.style.width = "425px";
	Imgid.style.left = "0";
	abc = Imgid;
	// }
}

function backtoNav() {
	var ccc = abc;
	ccc.style.width = "0";
	ccc.style.left = "-100px";

}



// header news ticker
$('#news_tcker_id').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 0,
	speed: 5000,
	pauseOnHover: false,
	cssEase: 'linear',
  variableWidth: true,
  });

$('#news_tcker_id_1').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 0,
	speed: 5000,
	pauseOnHover: false,
	cssEase: 'linear',
  variableWidth: true,
  });


$('.testimonial-row').slick({
  infinite: true,
  slidesToShow: 3,
  prevArrow: '<img class="prod_slider_prev" src="https://cdn.shopify.com/s/files/1/1010/9920/9043/files/arrow-slider-l.svg?v=1764542515" alt="img">',
  nextArrow: '<img class="prod_slider_next" src="https://cdn.shopify.com/s/files/1/1010/9920/9043/files/arrow-slider-r.svg?v=1764542515" alt="img">',
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow:3
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1
      }
    },
      {
          breakpoint: 576,
          settings: {
            slidesToShow: 1
          }
        }
    ]
});



//  ============  product page slider =============

$('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    prevArrow:'<i class="far fa-chevron-left prod_slider_prev"></i>',
    nextArrow:'<i class="far fa-chevron-right prod_slider_next"></i>',
    asNavFor: '.slider-nav'
});
$('.slider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    //  prevArrow:'<i class="far fa-chevron-left prod_slider_prev"></i>',
    // nextArrow:'<i class="far fa-chevron-right prod_slider_next"></i>',
    dots: false,
	arrows:false,
    focusOnSelect: true,
    verticalSwiping:true,

responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 5,
      }
    },
   
    {
      breakpoint: 576,
      settings: {
      slidesToShow: 4,
      }
    },
    {
      breakpoint: 380,
      settings: {
      slidesToShow: 3,
      }
    }
    ]
});


// mobile nav accordion
document.addEventListener("DOMContentLoaded", function () {
    const accordion = document.querySelectorAll('#myAccordion_pro .accordion-item');

    accordion.forEach(item => {
        const collapseEl = item.querySelector('.accordion-collapse');

        // // When opened → add active
        // collapseEl.addEventListener('show.bs.collapse', function () {
        //     item.classList.add('active');
        // });

        // When closed → remove active
        collapseEl.addEventListener('hide.bs.collapse', function () {
            item.classList.remove('active');
        });
    });
});



// mobile nav select

document.addEventListener("DOMContentLoaded", () => {
    const btn = document.querySelector(".lang-select-btn1");
    const menu = document.querySelector(".lang-select-menu1");

    btn.addEventListener("click", () => {
        menu.style.display = menu.style.display === "block" ? "none" : "block";
    });

    // Close dropdown when clicking outside
    document.addEventListener("click", (e) => {
        if (!btn.contains(e.target) && !menu.contains(e.target)) {
            menu.style.display = "none";
        }
    });
});

document.addEventListener("DOMContentLoaded", () => {
    const btn = document.querySelector(".lang-select-btn2");
    const menu = document.querySelector(".lang-select-menu2");

    btn.addEventListener("click", () => {
        menu.style.display = menu.style.display === "block" ? "none" : "block";
    });

    // Close dropdown when clicking outside
    document.addEventListener("click", (e) => {
        if (!btn.contains(e.target) && !menu.contains(e.target)) {
            menu.style.display = "none";
        }
    });
});




// mobile slider
$('.product_slider_mob1').slick({
    slidesToShow: 1.1,
    slidesToScroll: 1,
    centerMode: true,
    infinite: true,
    dots: false,
    arrows: true,
    prevArrow: '<button class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/1010/9920/9043/files/arrow-slider-l.svg?v=1764542515" alt=""></button>',
    nextArrow: '<button class="slick-next"><img src="https://cdn.shopify.com/s/files/1/1010/9920/9043/files/arrow-slider-r.svg?v=1764542515" alt=""></button>',
    responsive: [
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1.1
            }
        },
        {
            breakpoint: 320,
            settings: {
                slidesToShow: 1
            }
        }
    ]
});

$('.product_slider_mob2').slick({
    slidesToShow: 1.1,
    slidesToScroll: 1,
    centerMode: true,
    infinite: true,
    dots: false,
    arrows: true,
    prevArrow: '<button class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/1010/9920/9043/files/arrow-slider-l.svg?v=1764542515" alt=""></button>',
    nextArrow: '<button class="slick-next"><img src="https://cdn.shopify.com/s/files/1/1010/9920/9043/files/arrow-slider-r.svg?v=1764542515" alt=""></button>',
    responsive: [
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1.1
            }
        },
        {
            breakpoint: 320,
            settings: {
                slidesToShow: 1
            }
        }
    ]
});

$('.product_slider_mob3').slick({
    slidesToShow: 1.1,
    slidesToScroll: 1,
    centerMode: true,
    infinite: true,
    dots: false,
    arrows: true,
    prevArrow: '<button class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/1010/9920/9043/files/arrow-slider-l.svg?v=1764542515" alt=""></button>',
    nextArrow: '<button class="slick-next"><img src="https://cdn.shopify.com/s/files/1/1010/9920/9043/files/arrow-slider-r.svg?v=1764542515" alt=""></button>',
    responsive: [
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1.1
            }
        },
        {
            breakpoint: 320,
            settings: {
                slidesToShow: 1
            }
        }
    ]
});


// product buttons
  $(document).ready(function(){
    $('.sp-btn-1').click(function(){
        $('.sp-btn-2.active').removeClass('active');
        $('.sp-btn-3.active').removeClass('active');
        $(this).addClass('active');
    });

    $('.sp-btn-2').click(function(){
        $('.sp-btn-3.active').removeClass('active');
        $(this).addClass('active');
    });

  $('.sp-btn-3').click(function(){
      // $('.visiting-list-main ul .active').removeClass('active');
      $('.sp-btn-2').addClass('active');
      $(this).addClass('active');
  });
});

document.addEventListener('click', function (event) {
  const drawer = event.target.closest('menu-drawer');
  const isFacetClick = event.target.closest(
    '.facets__disclosure-vertical, .facets__summary, .facet-checkbox, price-range'
  );

  if (drawer && isFacetClick) {
    event.stopImmediatePropagation();
  }
}, true);

document.addEventListener("DOMContentLoaded", function () {
  const playBtn = document.getElementById("circle-play-b");
  const video = document.getElementById("video");
  const posterLayer = document.querySelector(".video-poster-layer");

  if (!playBtn || !video) return;

  playBtn.addEventListener("click", function () {
    // Hide poster + button
    if (posterLayer) {
      posterLayer.style.display = "none";
    }

    // Show video/iframe
    video.style.display = "block";

    // If MP4 video
    if (video.tagName === "VIDEO") {
      video.setAttribute("controls", "controls");
      video.play();
    }

    // If YouTube iframe → autoplay
    if (video.tagName === "IFRAME") {
      let src = video.getAttribute("src");
      if (!src.includes("autoplay=1")) {
        video.setAttribute("src", src + "&autoplay=1");
      }
    }
  });
});

new Swiper('.swiper', {
  slidesPerView: 1,
  centeredSlides: true,
  breakpoints: {
    768: {
      slidesPerView: 1
    },
    1024: {
      slidesPerView: 3
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const playBtn = document.getElementById("circle-play-b");
  const video = document.getElementById("video");
  const playWrapper = document.querySelector(".play-button-wrapper");

  if (!playBtn || !video) return;

  playBtn.addEventListener("click", function () {

    // If MP4 video
    if (video.tagName === "VIDEO") {
      video.play();
    }

    // If YouTube iframe (autoplay)
    if (video.tagName === "IFRAME") {
      let src = video.getAttribute("src");
      if (!src.includes("autoplay=1")) {
        video.setAttribute("src", src + "&autoplay=1");
      }
    }

    // Hide button smoothly
    if (playWrapper) {
      playWrapper.style.opacity = "0";
      playWrapper.style.pointerEvents = "none";
    }
  });

  // ALSO hide button when video starts playing (extra safety)
  if (video.tagName === "VIDEO") {
    video.addEventListener("play", function () {
      if (playWrapper) {
        playWrapper.style.opacity = "0";
        playWrapper.style.pointerEvents = "none";
      }
    });
  }
  if (video.tagName === "VIDEO") {
  video.addEventListener("pause", function () {
    if (playWrapper) {
      playWrapper.style.opacity = "1";
      playWrapper.style.pointerEvents = "auto";
    }
  });
}

});

function scrollToGeo() {
  const target = document.getElementById('geolocation-section');
  if (!target) return;

  const targetPosition = target.offsetTop - 100;
  const startPosition = window.pageYOffset;
  const distance = targetPosition - startPosition;
  const duration = 800; // milliseconds (1.2 seconds)
  let start = null;

  function animation(currentTime) {
    if (start === null) start = currentTime;

    const timeElapsed = currentTime - start;
    const progress = Math.min(timeElapsed / duration, 1);

    window.scrollTo(0, startPosition + distance * progress);

    if (timeElapsed < duration) {
      requestAnimationFrame(animation);
    }
  }

  requestAnimationFrame(animation);
}





